import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames'
import math from '../../../redux/modules/utils/math'
import utils from '../../utils/cartItemUtils'
import './styles.css'

export class CartModal extends Component {
  constructor(props) {
    super(props)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.timeout = null
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
    this.timeout = setTimeout(() => this.props.closeItemModal(), 10000)
  }

  componentWillUnmount() {
    // Cover case when you go to checkout
    if (!_.isEmpty(this.props.itemAdded)) this.props.closeItemModal()
    else clearTimeout(this.timeout)
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target))
      this.props.closeItemModal()
  }

  render() {
    const item = this.props.itemAdded
    return (
      <div id="CartModal" className="cartmodal" ref={(modal) => { this.wrapperRef = modal }}>
        <i className="icon-close" onClick={() => this.props.closeItemModal()} />
        <div className="msg"><i className="icon-check" />Item added to Cart</div>
        {!_.isEmpty(item) && (
          <div className="item">
            <div className="thumbnail">
              {item.type !== 'plan' && (
                <img src={item.thumbnail.cartThumb} alt="Cart item" />
              )}
            </div>
            <div className="description">
              <div className={classnames('type', { blue: item.type !== 'physical' })}>
                <span>{utils.getNaturalType(item.orderedModel, item.product)}</span>
              </div>
              <div className="title">
                <span>{utils.getTitle(item.orderedModel, item.product)}</span>
              </div>
            </div>
            <div className="price">
              <span>${math.toFixed(item.price)}</span>
            </div>
          </div>
        )}
        <div className="bottom">
          <Link to="/checkout" className="btn -orange">Checkout</Link>
        </div>
      </div>
    )
  }
}

CartModal.propTypes = {
  closeItemModal: PropTypes.func.isRequired,
  itemAdded: PropTypes.shape({
    id: PropTypes.number.isRequired,
    product: PropTypes.object.isRequired,
    orderedModel: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    thumbnail: PropTypes.shape({
      cartThumb: PropTypes.string.isRequired
    }).isRequired,
    type: PropTypes.string.isRequired
  }).isRequired
}

export default CartModal
